module.exports = __webpack_public_path__ + "img/fen.b22f4dcc.png";